<template>
  <div
    class="primary--text text-uppercase font-weight-medium font-italic"
    :class="{
      'text-h4 text-sm-h3 text-lg-h2': !small,
      'text-h5 text-lg-h4': small,
    }"
  >
    <span class="font-secondary">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
